import React from "react";
import { useSiteContent } from "@/lib/siteContent";

export const Process = () => {
  const { content } = useSiteContent();
  const STEPS = content.process_steps || [];
  return (
    <section id="process" className="py-24 lg:py-32 bg-[#FDFBF7]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <div className="text-[11px] uppercase tracking-[0.3em] text-[#CBA358] font-semibold">
            {content.process_eyebrow}
          </div>
          <h2 className="font-display text-4xl lg:text-5xl mt-4 text-[#0A2342] leading-[1.05] text-balance">
            {content.process_headline}
          </h2>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {STEPS.map((s, i) => (
            <div
              key={i}
              className="group relative bg-white border border-[#E5DFD3] p-8 hover:-translate-y-1 hover:border-[#0A2342] transition-all"
            >
              <div className="absolute -top-6 left-7 font-display text-7xl font-bold text-[#CBA358] leading-none">
                {s.num || String(i + 1).padStart(2, "0")}
              </div>
              <div className="pt-8">
                <h3 className="font-display text-2xl text-[#0A2342]">{s.title}</h3>
                <p className="mt-3 text-[#5C636A] leading-relaxed text-[15px]">{s.body}</p>
              </div>
              {i < STEPS.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-3 w-6 h-px bg-[#E5DFD3]" />
              )}
            </div>
          ))}
        </div>

        <div
          id="assessment"
          className="mt-12 flex flex-wrap items-center gap-4 p-6 bg-[#F4EFE6] border-l-4 border-[#CBA358]"
        >
          <span className="text-[11px] uppercase tracking-[0.22em] font-bold text-[#0A2342]">
            Step 2 →
          </span>
          <span className="text-[#0A2342] font-body">
            {content.process_step2_note}
          </span>
          <a
            href={content.google_form_url || "#"}
            target="_blank"
            rel="noreferrer"
            data-testid="assessment-form-link"
            className="ml-auto text-[#0A2342] underline underline-offset-4 hover:text-[#CBA358] text-sm font-medium"
          >
            Preview the form →
          </a>
        </div>
      </div>
    </section>
  );
};

export default Process;
